import { render, staticRenderFns } from "./defaulePage.vue?vue&type=template&id=e8db19e6&scoped=true&"
import script from "./defaulePage.vue?vue&type=script&lang=js&"
export * from "./defaulePage.vue?vue&type=script&lang=js&"
import style0 from "./defaulePage.vue?vue&type=style&index=0&id=e8db19e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8db19e6",
  null
  
)

export default component.exports